module.exports = __webpack_public_path__ + "static/img/MPR_Icons_plus.22963055.svg";